module.exports = __webpack_public_path__ + "img/finland-liver-cancer-male.9ca22bc1.png";